import React, { memo, useMemo } from "react"
import { graphql, useStaticQuery } from "gatsby"
import { Tabs, Tab, TabList, TabPanels, TabPanel, VStack } from "@chakra-ui/react"

import { ProductContentDescription } from "@app/components/Product/Content/ProductContentDescription"
import { ProductContentCare } from "@app/components/Product/Content/ProductContentCare"
import { ProductContentFabric } from "@app/components/Product/Content/ProductContentFabric"

import type { ProductCombinedProps } from "@root/types/global"

type Props = {
  product: ProductCombinedProps
}

export const ProductContent: React.FC<Props> = memo(({ product }) => {
  const { product: locales } = useStaticQuery<GatsbyTypes.ProductContentQuery>(graphql`
    query ProductContent {
      product: sanityTemplateProduct {
        additionalDetails
        additionalDescription
        additionalCare
        additionalFabric
        additionalSKU
      }
    }
  `)

  const care = useMemo(() => product?.care?.care_instructions, [product?.care?.care_instructions])
  const description = useMemo(() => product?.descriptionHtml || product?.description, [product])
  const fabric = useMemo(() => product?.composition?.composition, [product?.composition?.composition])

  return description || care || fabric ? (
    <VStack alignItems="stretch" justifyContent="space-between" h="full" spacing={[10, 4]} w="full" maxW="container.md">
      <VStack alignItems="stretch" justifyContent="flex-start" w="full" spacing={8.75} marginTop={4}>
        <Tabs variant="productContent">
          <TabList>
            {description && <Tab color="grey.text">{locales?.additionalDescription}</Tab>}
            {fabric && <Tab color="grey.text">Composition</Tab>}
            {care && <Tab color="grey.text">{locales?.additionalCare}</Tab>}
          </TabList>
          <TabPanels>
            {description && (
              <TabPanel>
                <VStack alignItems="stretch" justifyContent="flex-start" spacing={4}>
                  <ProductContentDescription product={product} />
                </VStack>
              </TabPanel>
            )}
            {fabric && (
              <TabPanel>
                <VStack alignItems="stretch" justifyContent="flex-start" spacing={4}>
                  <ProductContentFabric product={product} fabricLocale={locales?.additionalFabric} fabric={fabric} />
                </VStack>
              </TabPanel>
            )}
            {care && (
              <TabPanel>
                <ProductContentCare care={care} />
              </TabPanel>
            )}
          </TabPanels>
        </Tabs>
      </VStack>
    </VStack>
  ) : null
})
